webpackJsonp([10258973847733],{

/***/ 1724:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CoownerBreakdown","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"client","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"OBJECT","name":"Client","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"clientId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"total","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"Decimal","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"totalCents","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"Int","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-coowner-breakdown-ebb66b82171fe363f895.js